const common = {
  // Nav
  nav_home: 'Home',
  nav_about: 'About Us',
  nav_services: 'Services',
  nav_cases: 'Success Cases',
  nav_knowledge: 'Knowledge',
  nav_contact: 'Contact',
  nav_consult: 'Free Consult',
  nav_switch_lang: 'Switch Language',
  nav_service_overview: 'Service Overview',
  nav_service_ivf: 'Third-Gen IVF',
  nav_service_surrogacy: 'Single Surrogacy',
  nav_service_full: 'IVF + Surrogacy',

  // Hero
  hero_title1: '3G IVF · Surrogacy · Full Service',
  hero_title2: 'Kyrgyzstan Fertility Center',
  hero_subtitle: 'Three core services, flexible plans, from IVF to bringing your baby home — professional care at every step',
  hero_cta1: 'Free Consultation',
  hero_cta2: 'Learn More',
  hero_stat1: 'Success Cases',
  hero_stat2: 'Specialists',
  hero_stat3: 'Years Service',
  hero_stat4: 'Certifications',
  hero_prev_slide: 'Previous',
  hero_next_slide: 'Next',
  hero_slide_to: 'Go to slide {{n}}',

  // Brand
  brand_name: 'Kyrgyzstan IVF Surrogacy Center',
  brand_sub: 'Surrogacy Center',

  // Services
  services_title: 'Our Services',
  services_subtitle: 'Comprehensive assisted reproduction services from medical planning to legal protection',
  services_label: 'Our Services',
  service_surrogacy: 'Single Surrogacy',
  service_surrogacy_desc: 'Surrogacy service for clients with existing embryos, strict surrogate screening, full pregnancy monitoring, legal rights protection',
  service_ivf: 'Third-Gen IVF',
  service_ivf_desc: 'PGT-A genetic screening IVF, single-cycle 8-embryo screening, higher success rate and lower miscarriage risk',
  service_egg: 'IVF + Surrogacy',
  service_egg_desc: 'Full IVF + surrogacy chain service, from ovulation stimulation to baby returning home, one-stop dream solution',
  service_legal: 'Legal Support',
  service_legal_desc: 'Legal policy in Kyrgyzstan, parental rights guaranteed, birth certificate processing',
  service_more: 'Learn More',

  // WhyUs
  whyus_label: 'Why Choose Us',
  whyus_title: 'Why Choose Us',
  whyus_floating_label: 'success cases, happy families worldwide',
  whyus_legal: 'Legal Protection',
  whyus_legal_desc: 'Surrogacy is legal in Kyrgyzstan with clear parental rights protection',
  whyus_medical: 'Top Medical Resources',
  whyus_medical_desc: 'Partnered with top fertility hospitals, advanced IVF/PGT technology',
  whyus_global: 'Global Chinese Service',
  whyus_global_desc: 'Trilingual professional team (Chinese/English/Russian), full Chinese-language support',
  whyus_transparent: 'Transparent Pricing',
  whyus_transparent_desc: 'No hidden fees, detailed quotes, comprehensive package service',
  whyus_consultant: 'Personal Consultant',
  whyus_consultant_desc: 'From first consultation to baby birth, dedicated consultant throughout',
  whyus_experience: '10 Years Experience',
  whyus_experience_desc: 'Over 500 successful cases, rich practical experience',

  // Testimonials
  testimonials_label: 'Testimonials',
  testimonials_title: 'Client Testimonials',
  testimonial_name1: 'Ms. Zhao & Mr. Wang',
  testimonial_loc1: 'Beijing',
  testimonial_content1: 'From the first consultation to the baby\'s birth, the RTB team was with us every step, making us feel the warmth of home in a foreign country. Thank you to every team member — you helped us realize our years-long dream.',
  testimonial_service1: 'Surrogacy + IVF',
  testimonial_name2: 'Li Family',
  testimonial_loc2: 'Shanghai',
  testimonial_content2: 'We were almost hopeless after multiple IVF failures. A friend recommended RTB. The consultant patiently analyzed our situation, designed a third-gen IVF plan, and we succeeded on the first transfer!',
  testimonial_service2: 'Third-Gen IVF',
  testimonial_name3: 'Марина К.',
  testimonial_loc3: 'Moscow',
  testimonial_content3: 'The RTB team was very professional and caring. The entire process went smoothly, and now we have our long-awaited baby.',
  testimonial_service3: 'IVF + Surrogacy',

  // Cases
  cases_title: 'Success Stories',
  cases_subtitle: 'Every baby is a miracle — real stories from happy families',
  cases_view_all: 'View All Cases',
  cases_share: 'Share',
  cases_share_modal_title: 'Share Story',
  cases_share_modal_desc: 'Spread love and hope, let more families learn about us',
  cases_cat_all: 'All Cases',
  cases_cat_surrogacy: 'Single Surrogacy',
  cases_cat_ivf: 'Third-Gen IVF',
  cases_cat_full: 'IVF + Surrogacy',
  cases_filter_desc: 'View real family stories by service type',
  cases_no_data: 'No cases in this category, please try another',
  cases_stats_stories: 'Success Stories',
  cases_stats_countries: 'Countries Served',
  cases_stats_satisfaction: 'Satisfaction Rate',
  cases_stats_years: 'Years Experience',
  cases_cta_title: 'Your Happiness Story Starts Here',
  cases_cta_desc: 'Book a free consultation and take the first step toward your dream',
  cases_page_sub: 'Real stories from happy families',
  cases_section_label: 'Success Stories',

  // Knowledge
  knowledge_title: 'Knowledge Center',
  knowledge_subtitle: 'Professional medical knowledge to answer all your questions',
  knowledge_view_all: 'View All Articles',
  knowledge_cat_all: 'All',
  knowledge_cat_guide: 'Guides',
  knowledge_cat_medical: 'Medical',
  knowledge_cat_faq: 'FAQ',
  knowledge_cat_legal: 'Legal',
  knowledge_read_full: 'Read Full Article',
  knowledge_related_title: 'Related Articles',
  knowledge_more_title: 'More Articles',
  knowledge_share: 'Share:',
  knowledge_not_found: 'Article not found',
  knowledge_back: 'Back to Knowledge Center',
  knowledge_loading: 'Loading...',
  knowledge_loading_articles: 'Loading articles...',
  knowledge_no_articles: 'No articles found',
  knowledge_sidebar_tags: 'Popular Tags',
  knowledge_sidebar_stats: 'Category Stats',
  knowledge_sidebar_cta: 'Have Questions? Contact Us',
  knowledge_sidebar_cta_desc: 'Professional consultants answer your questions within 24 hours, free of charge',
  knowledge_sidebar_cta_btn: 'Free Consultation',
  knowledge_tag_articles: 'articles',
  knowledge_tag_related: 'All articles related to "{{tag}}"',
  knowledge_tag_view_all: 'View All Articles',
  knowledge_section_label: 'Knowledge Center',
  knowledge_filter_placeholder: 'Search articles...',
  knowledge_current_tag_filter: 'Current tag filter:',
  knowledge_clear_filter: 'Clear filter',

  // FAQ
  faq_title: 'Frequently Asked Questions',
  faq_subtitle: 'Quick answers to the most common questions',
  faq_label: 'FAQ',
  faq_cat_all: 'All',
  faq_cat_process: 'Process',
  faq_cat_medical: 'Medical',
  faq_cat_legal: 'Legal',
  faq_cat_cost: 'Cost',
  faq_no_data: 'No FAQs available',
  faq_load_error: 'Failed to load FAQs',

  // Appointment
  appt_title: 'Book a Free Consultation',
  appt_subtitle: 'Fill in the form and our specialist will contact you within 24 hours',
  appt_name: 'Your Name',
  appt_phone: 'Phone Number',
  appt_wechat: 'WeChat ID',
  appt_email: 'Email Address',
  appt_service: 'Service Interest',
  appt_message: 'Additional Notes',
  appt_submit: 'Book Now',
  appt_success: 'Booked successfully! We will contact you soon.',
  appt_service_opt1: 'Single Surrogacy',
  appt_service_opt2: 'Third-Gen IVF',
  appt_service_opt3: 'IVF + Surrogacy',
  appt_service_opt4: 'General Inquiry',
  appt_label: 'Free Consultation',
  appt_form_title: 'Book a Free Consultation',
  appt_form_desc: 'Fill in your details and a consultant will contact you within 24 hours',
  appt_form_privacy: 'Strict Privacy Protection',
  appt_form_wechat_hint: 'Or add WeChat: 16600032397',
  appt_form_name_placeholder: 'Enter your name',
  appt_form_phone_placeholder: '+86 or international number',
  appt_form_wechat_placeholder: 'WeChat ID (optional)',
  appt_form_email_placeholder: 'email@example.com (optional)',
  appt_form_service_placeholder: 'Select consultation service',
  appt_form_message_placeholder: 'Describe your situation or needs (age, prior tests, IVF history, etc.), max 500 characters',
  appt_form_contact_soon: 'We will contact you within 24 hours, please keep your phone available',

  // Contact
  contact_title: 'Contact Us',
  contact_subtitle: 'We are always here to help you',
  contact_phone: 'Phone',
  contact_wechat: 'WeChat',
  contact_email: 'Email',
  contact_address: 'Office Address',
  contact_scan_wechat: 'Scan for WeChat',
  contact_scan_whatsapp: 'Scan for WhatsApp',
  contact_online: 'Online Chat',
  contact_label: 'Contact Us',
  contact_info_title: 'Contact Info',
  contact_qr_title: 'Scan to Connect',
  contact_wechat_click: '(Tap to view QR code)',
  contact_form_title: 'Online Consultation',
  contact_form_desc: 'Fill in the form and a consultant will contact you within 24 hours',
  contact_form_privacy: 'We are committed to protecting your privacy',
  contact_map_title: 'Office Location',
  contact_map_title_attr: 'Bishkek, Kyrgyzstan Office Location',

  // CTA Banner
  cta_label: 'Free Consultation · 免费咨询',
  cta_title1: 'Start Your Journey to Parenthood',
  cta_title2: 'Consultant Responds Within 24 Hours',
  cta_desc: 'Wherever you are, our professional Chinese-speaking team is always available. From first consultation to baby birth, we are with you every step.',
  cta_btn1: 'Free Consultation',
  cta_btn2: 'View Success Stories',
  cta_badge1: 'Legal Surrogacy Protection',
  cta_badge2: 'Strict Privacy Protection',
  cta_badge3: 'Trilingual Service',
  cta_badge4: 'Personal Consultant',

  // Footer
  footer_rights: '© 2026 Kyrgyzstan IVF Surrogacy Center. All rights reserved.',
  footer_privacy: 'Privacy Policy',
  footer_terms: 'Terms of Service',
  footer_desc: 'Professional IVF surrogacy services in Kyrgyzstan, guiding you on the path to a happy family.',
  footer_quick_links: 'Quick Links',
  footer_contact: 'Contact Info',
  footer_scan: 'Scan to Connect',
  footer_phone: '+86 16600032397',
  footer_email: 'ivfjason@gmail.com',
  footer_address: 'Bishkek, Kyrgyzstan',
  footer_wechat_label: 'WeChat',
  footer_whatsapp_label: 'WhatsApp',

  // About
  about_title: 'About Us',
  about_subtitle: 'A decade of dedication to help every family realize their dream',
  about_desc1: 'Kyrgyzstan IVF Surrogacy Center was founded in 2014, specializing in assisted reproduction in Central Asia. We provide safe, legal and efficient fertility solutions for intended parents worldwide.',
  about_desc2: 'Kyrgyzstan law explicitly protects the parental rights of commissioning parties, making it one of the few countries with an open and fully regulated framework for surrogacy.',
  about_mission: 'Our Mission',
  about_mission_desc: 'To help every family that dreams of a child realize that dream, with professionalism and care in every step.',

  // Services page
  svc_intro: 'Comprehensive assisted reproduction services from medical planning to legal protection',
  svc_ivf_title: 'Third-Gen IVF',
  svc_ivf_subtitle: 'PGT-A Third-Generation IVF',
  svc_ivf_desc: 'Single-cycle third-gen IVF package including specialist consultation, ovulation stimulation, egg retrieval, ICSI, embryo culture (5-7 days), biopsy, PGT-A screening (8 embryos), one embryo transfer, 1-year embryo cryopreservation.',
  svc_surrogacy_title: 'Single Surrogacy',
  svc_surrogacy_subtitle: 'Surrogacy service for existing embryos',
  svc_surrogacy_desc: 'Exclusive surrogacy service for clients with existing embryos. Includes surrogate screening, pregnancy blood test, monthly prenatal checkups, surrogate living compensation, 1-year embryo storage, full pregnancy monitoring, delivery at licensed maternity hospital, birth certificate, DNA test, newborn repatriation.',
  svc_full_title: 'IVF + Surrogacy',
  svc_full_subtitle: 'Complete IVF + Surrogacy service',
  svc_full_desc: 'One-stop full chain service from ovulation stimulation to baby returning home. Three plans: Economy, Premium, and Comprehensive for different needs and budgets.',
  svc_cta_title: 'Not sure which plan is right for you?',
  svc_cta_desc: 'Contact our professional consultants for a free personalized service plan recommendation',
  svc_section_label: 'Services',

  // IVF detail page
  ivf_breadcrumb_svc: 'Services',
  ivf_breadcrumb: 'Third-Gen IVF (PGT-A)',
  ivf_label: 'Third-Generation IVF',
  ivf_page_title: 'Third-Gen IVF (PGT-A)',
  ivf_hero_desc: 'Single-cycle third-gen IVF package including all embryo culture, biopsy, PGT-A screening (8 embryos), ICSI, and 1-year embryo cryopreservation.',
  ivf_cta_consult: 'Free Consultation',
  ivf_cta_whatsapp: 'WhatsApp Chat',
  ivf_stat_price: 'Single Cycle Cost',
  ivf_stat_screen: 'PGT-A Embryo Screening',
  ivf_stat_rate: 'Under 35 Success Rate',
  ivf_stat_freeze: 'Embryo Freeze Duration',
  ivf_process_title: 'Complete IVF Process',
  ivf_process_sub: 'Eight steps with professional medical team support at every stage',
  ivf_process_label: 'IVF Complete Process',
  ivf_included_title: 'What\'s Included',
  ivf_included_sub: 'Single-cycle third-gen IVF $19,000 package details',
  ivf_extra_title: 'Optional Additional Costs',
  ivf_extra_sub: 'Common additional cost items, charged as needed',
  ivf_cta_title: 'Begin Your Third-Gen IVF Journey',
  ivf_cta_desc: 'Professional medical consultant answers your questions and helps design the best IVF plan',

  // IVF steps
  ivf_step1_title: 'Plan & Assessment',
  ivf_step1_dur: 'Week 1-2',
  ivf_step1_desc: 'Remote and local specialist consultation, comprehensive fertility assessment for both partners. Includes ovarian reserve (AMH/AFC), semen analysis, uterine evaluation, karyotype testing, and personalized IVF plan.',
  ivf_step1_p1: 'Remote + local specialist consultation',
  ivf_step1_p2: 'Ovarian reserve AMH/AFC testing',
  ivf_step1_p3: 'Semen analysis & morphology',
  ivf_step1_p4: 'Karyotype chromosome testing',
  ivf_step2_title: 'Controlled Ovarian Stimulation',
  ivf_step2_dur: 'Week 2-4',
  ivf_step2_desc: 'Personalized stimulation protocol with daily gonadotropin injections to stimulate multiple follicle development. Close monitoring of follicle growth. Domestic medication costs not included.',
  ivf_step2_p1: 'Personalized stimulation protocol',
  ivf_step2_p2: 'Continuous ultrasound monitoring',
  ivf_step2_p3: 'Dynamic hormone level testing',
  ivf_step2_p4: 'Timely protocol adjustments',
  ivf_step3_title: 'Egg Retrieval',
  ivf_step3_dur: 'Week 4-5',
  ivf_step3_desc: 'When dominant follicles reach maturity (18-22mm), HCG trigger is given, with retrieval 36 hours later. Transvaginal ultrasound-guided retrieval under IV sedation, approximately 20-30 minutes.',
  ivf_step3_p1: 'IV sedation painless retrieval',
  ivf_step3_p2: 'Ultrasound precision guidance',
  ivf_step3_p3: 'Experienced physician operation',
  ivf_step3_p4: 'Same-day recovery possible',
  ivf_step4_title: 'Sperm Prep & ICSI',
  ivf_step4_dur: 'Same day as retrieval',
  ivf_step4_desc: 'Semen collected on retrieval day, processed by density gradient centrifugation to select optimal sperm. ICSI injects a single sperm directly into each oocyte.',
  ivf_step4_p1: 'Density gradient sperm selection',
  ivf_step4_p2: 'ICSI single sperm injection',
  ivf_step4_p3: 'Sperm motility assessment',
  ivf_step4_p4: 'Frozen sperm backup option',
  ivf_step5_title: 'Culture & Embryo Development',
  ivf_step5_dur: 'Day 5-10',
  ivf_step5_desc: 'Fertilized eggs cultured in constant-temperature incubator for 5-7 days to blastocyst stage. Time-lapse imaging monitors embryo development continuously.',
  ivf_step5_p1: 'Advanced culture media system',
  ivf_step5_p2: 'Time-lapse dynamic monitoring',
  ivf_step5_p3: 'All embryos cultured to blastocyst',
  ivf_step5_p4: 'Gardner grading system evaluation',
  ivf_step6_title: 'PGT-A Genetic Screening',
  ivf_step6_dur: 'Day 10-30',
  ivf_step6_desc: 'All blastocysts undergo biopsy for PGT-A chromosome euploidy screening. Package includes 8 embryo PGT-A screening, additional $550/embryo.',
  ivf_step6_p1: 'All embryos biopsied',
  ivf_step6_p2: 'PGT-A chromosome euploidy screening',
  ivf_step6_p3: 'Package includes 8 embryos',
  ivf_step6_p4: 'PGT-M single-gene screening optional',
  ivf_step7_title: 'Embryo Transfer',
  ivf_step7_dur: 'Cycle 2-5 after period',
  ivf_step7_desc: 'Highest-quality embryo transferred via soft catheter through cervix under ultrasound guidance, no anesthesia needed, approximately 5-10 minutes. One transfer per package.',
  ivf_step7_p1: 'Non-invasive soft catheter transfer',
  ivf_step7_p2: 'Real-time ultrasound guidance',
  ivf_step7_p3: 'One transfer per cycle',
  ivf_step7_p4: 'Blood HCG test after 14 days',
  ivf_step8_title: 'Pregnancy Test & Monitoring',
  ivf_step8_dur: '2-8 weeks post-transfer',
  ivf_step8_desc: 'Blood HCG test 14 days after transfer to confirm pregnancy. Continuous monitoring of HCG and progesterone, ultrasound at 5-6 weeks to confirm intrauterine pregnancy and heartbeat.',
  ivf_step8_p1: 'Blood HCG precise pregnancy test',
  ivf_step8_p2: 'Ultrasound confirmation of heartbeat',
  ivf_step8_p3: 'Luteal support adjustments',
  ivf_step8_p4: 'Close early pregnancy follow-up',

  // IVF included items
  ivf_item1_title: 'Specialist Consultation',
  ivf_item1_desc: 'Remote and local consultation, both hospitals coordination for stimulation plan.',
  ivf_item2_title: 'Time-Lapse Culture Monitoring',
  ivf_item2_desc: 'Advanced time-lapse incubator, 24/7 embryo development monitoring for precise quality assessment.',
  ivf_item3_title: 'Test Result Evaluation',
  ivf_item3_desc: 'Pre-cycle evaluation of all necessary test items, personalized protocol design.',
  ivf_item4_title: 'Stimulation & Retrieval',
  ivf_item4_desc: 'One stimulation and retrieval each, IV sedation painless procedure with ultrasound guidance.',
  ivf_item5_title: 'ICSI Single Sperm Injection',
  ivf_item5_desc: 'Micro-manipulation to inject single high-quality sperm directly into each oocyte.',
  ivf_item6_title: 'All Embryo Culture',
  ivf_item6_desc: 'All embryos cultured 5-7 days to blastocyst stage using advanced culture media.',
  ivf_item7_title: 'All Embryo Biopsy',
  ivf_item7_desc: 'Trophectoderm biopsy on all blastocysts for PGT-A screening sample collection.',
  ivf_item8_title: 'PGT-A Screening (8 Embryos)',
  ivf_item8_desc: 'Single-cycle 8 embryo PGT-A chromosome euploidy screening, $550/extra embryo.',
  ivf_item9_title: 'One Embryo Transfer',
  ivf_item9_desc: 'One transfer per cycle, ultrasound-guided soft catheter precise implantation.',
  ivf_item10_title: '1-Year Embryo Freeze',
  ivf_item10_desc: 'Remaining embryos vitrified for 1 year, 99%+ survival rate.',
  ivf_item11_title: 'Local Kyrgyzstan Service',
  ivf_item11_desc: 'Medical interpreter, airport pickup (one round trip), hospital-area hotel medical transport.',
  ivf_item12_title: 'Living Essentials',
  ivf_item12_desc: '2 SIM cards, 1 power adapter, apartment/hotel booking assistance.',

  // IVF extra costs
  ivf_extra1_title: 'Abdominal Retrieval',
  ivf_extra1_price: 'TBD',
  ivf_extra1_desc: 'When transvaginal retrieval is unsuitable',
  ivf_extra2_title: 'Extra Embryo PGT-A',
  ivf_extra2_price: '$550/embryo',
  ivf_extra2_desc: 'Package includes 8, additional embryos',
  ivf_extra3_title: 'PGT-M Screening',
  ivf_extra3_price: '$800/embryo',
  ivf_extra3_desc: 'Single-gene disorder screening',
  ivf_extra4_title: 'Second Stimulation + Meds',
  ivf_extra4_price: '$14,000/cycle',
  ivf_extra4_desc: 'Includes 8 embryo PGT-A screening',
  ivf_extra5_title: 'Donor Gametes',
  ivf_extra5_price: 'On demand',
  ivf_extra5_desc: 'KG/KZ/RU international donors',
  ivf_extra6_title: 'Sperm Biochemical Separation',
  ivf_extra6_price: '$700',
  ivf_extra6_desc: 'Additional frozen sperm processing',
  ivf_extra7_title: 'Testicular Sperm Extraction',
  ivf_extra7_price: 'TBD',
  ivf_extra7_desc: 'When ejaculation is difficult',
  ivf_extra8_title: 'E-Visa',
  ivf_extra8_price: 'Current rate',
  ivf_extra8_desc: 'Kyrgyzstan electronic visa',
  ivf_extra9_title: 'Round-Trip Flights',
  ivf_extra9_price: 'At cost',
  ivf_extra9_desc: 'Subject to market rates',
  ivf_extra10_title: 'Domestic Injection Service',
  ivf_extra10_price: 'Self-paid',
  ivf_extra10_desc: 'At-home injection during stimulation',
  ivf_extra11_title: 'Post-Transfer Injection',
  ivf_extra11_price: 'Self-paid',
  ivf_extra11_desc: 'Luteal support injections',
  ivf_extra12_title: 'Post-Pregnancy Medication',
  ivf_extra12_price: 'Self-paid',
  ivf_extra12_desc: 'Pregnancy support medication cost',

  // Surrogacy detail page
  scy_breadcrumb: 'Single Surrogacy',
  scy_label: 'Single Surrogacy',
  scy_page_title: 'Single Surrogacy',
  scy_hero_desc: 'Exclusive surrogacy service for clients with existing embryos. From surrogate screening to baby repatriation, full professional support.',
  scy_stat_price1: 'Economy Plan From',
  scy_stat_price2: 'Premium Plan From',
  scy_stat_cases: 'Success Cases',
  scy_stat_legal: 'Legal Parental Rights',
  scy_process_title: 'Complete Surrogacy Process',
  scy_process_sub: 'From initial consultation to baby repatriation, full transparency and professional support',
  scy_process_label: 'Complete Process',
  scy_included_title: 'What\'s Included',
  scy_included_sub: 'Surrogacy package details (Economy/Premium two plans)',
  scy_extra_title: 'Optional Additional Costs',
  scy_extra_sub: 'Common additional cost items, charged as needed',
  scy_plan_title: 'Plan Comparison',
  scy_plan_sub: 'Choose the best plan for your needs and budget',
  scy_plan_label: 'Pricing Plans',
  scy_plan_note_title: 'Cost Notes & Inclusions',
  scy_plan_inc_title: 'Typically Included:',
  scy_plan_extra_title: 'Possible Additional Costs:',
  scy_plan_note: '* Reference ranges only. Actual costs vary by plan selection, medical conditions, and exchange rates. Contact our medical consultant for a precise personalized quote.',
  scy_plan_economy: 'Economy Plan',
  scy_plan_economy_badge: 'Budget Choice',
  scy_plan_economy_desc: 'Best for clients with straightforward process expectations',
  scy_plan_premium: 'Premium Plan',
  scy_plan_premium_badge: 'Most Popular',
  scy_plan_premium_desc: 'Includes pregnancy risk compensation, more distributed payments, less pressure',
  scy_plan_btn: 'Get Detailed Quote',
  scy_cta_title: 'Ready to Start Your Journey to Parenthood?',
  scy_cta_desc: 'Book a free consultation. Your dedicated consultant will answer all questions and design a personalized plan',

  // Surrogacy steps
  scy_step1_title: 'Free Initial Consultation',
  scy_step1_dur: 'Week 1-2',
  scy_step1_desc: 'Contact an RTB professional consultant for a free initial video or phone consultation. The consultant will thoroughly understand your needs, existing embryos, budget, and recommend the most suitable surrogacy plan (Premium or Economy).',
  scy_step1_p1: 'Dedicated consultant one-on-one service',
  scy_step1_p2: 'Existing embryo assessment',
  scy_step1_p3: 'Transparent plan and cost explanation',
  scy_step1_p4: 'Sign service agreement',
  scy_step2_title: 'Surrogate Screening & Matching',
  scy_step2_dur: 'Month 1-3',
  scy_step2_desc: 'Match from our database of rigorously health-screened surrogates. Candidates undergo triple health screening certification and psychological assessment. You can review health profiles and confirm the match.',
  scy_step2_p1: 'Hundreds of candidate surrogates',
  scy_step2_p2: 'Triple health screening certification',
  scy_step2_p3: 'Psychological health assessment',
  scy_step2_p4: 'Comprehensive trait and background matching',
  scy_step3_title: 'Medical Check & Preparation',
  scy_step3_dur: 'Week 2-4',
  scy_step3_desc: 'Surrogate undergoes comprehensive health check including blood tests, infectious disease screening, gynecological exam. Simultaneously evaluate your embryo quality and determine transfer protocol and timeline.',
  scy_step3_p1: 'Comprehensive surrogate health check',
  scy_step3_p2: 'Blood tests & infectious disease screening',
  scy_step3_p3: 'Embryo quality assessment',
  scy_step3_p4: 'Transfer protocol planning',
  scy_step4_title: 'Embryo Transfer',
  scy_step4_dur: 'Month 3-4',
  scy_step4_desc: 'Highest-quality embryo transferred to surrogate uterus via soft catheter under ultrasound guidance. Single surrogacy package includes one transfer. Blood pregnancy test 14 days after transfer.',
  scy_step4_p1: 'Ultrasound-guided precise transfer',
  scy_step4_p2: 'One embryo transfer',
  scy_step4_p3: '14-day blood pregnancy test',
  scy_step4_p4: 'Luteal support protocol',
  scy_step5_title: 'Full Pregnancy Monitoring',
  scy_step5_dur: 'Month 4-9',
  scy_step5_desc: 'Throughout pregnancy, our professional medical team monitors the surrogate health status, conducts monthly prenatal checkups, syncs pregnancy reports in real time, coordinates video calls so you can stay updated on your baby development.',
  scy_step5_p1: 'Monthly prenatal report sync',
  scy_step5_p2: '24/7 medical support',
  scy_step5_p3: 'Surrogate living compensation',
  scy_step5_p4: 'Nutritional & psychological care',
  scy_step6_title: 'Baby Birth',
  scy_step6_dur: 'Around due date',
  scy_step6_desc: 'Baby is delivered naturally at a licensed maternity hospital. Dedicated companion during delivery, professional newborn care. The hospital directly assists with postpartum paperwork, with the commissioning parents registered as legal parents on the birth certificate.',
  scy_step6_p1: 'Licensed maternity hospital natural birth',
  scy_step6_p2: 'Parents directly registered on birth certificate',
  scy_step6_p3: 'Professional newborn care',
  scy_step6_p4: 'Full birth accompaniment service',
  scy_step7_title: 'Documents & Return Home',
  scy_step7_dur: '1-2 months after birth',
  scy_step7_desc: 'Assistance with DNA paternity testing, newborn birth certificate, Hague apostille, return visa and travel permit — full support to bring your baby home smoothly.',
  scy_step7_p1: 'DNA paternity testing',
  scy_step7_p2: 'Birth certificate + Hague apostille',
  scy_step7_p3: 'Chinese passport/visa application',
  scy_step7_p4: 'Full repatriation support',
  // Surrogacy included items
  scy_item1_title: 'Surrogate Screening & Checkup',
  scy_item1_desc: 'Rigorous screening and necessary health checks, triple certification to ensure surrogate physical and mental health.',
  scy_item2_title: 'Blood Pregnancy Test',
  scy_item2_desc: 'Sensitive blood test to confirm pregnancy, accurate 14 days post-transfer, ensuring reliable results.',
  scy_item3_title: 'Monthly Prenatal Checkups',
  scy_item3_desc: 'Monthly necessary prenatal checkups for surrogate, full pregnancy report interpretation and assessment, 24/7 medical team response.',
  scy_item4_title: 'Surrogate Living Compensation',
  scy_item4_desc: 'Includes surrogate clothing, living, nutrition expenses and living compensation to ensure quality of life during pregnancy.',
  scy_item5_title: '1-Year Embryo Freeze',
  scy_item5_desc: 'Remaining embryos vitrified for 1 year, 99%+ survival rate, ready for thaw and transfer anytime.',
  scy_item6_title: 'Video Call Coordination',
  scy_item6_desc: 'Coordinate video calls with surrogate so you can stay updated on baby development with seamless communication.',
  scy_item7_title: 'Delivery Companion Service',
  scy_item7_desc: 'Dedicated companion during delivery, licensed maternity hospital natural birth, professional newborn care.',
  scy_item8_title: 'Birth Medical Certificate',
  scy_item8_desc: 'Assistance with newborn birth medical certificate, commissioning parents directly registered as legal parents.',
  scy_item9_title: 'DNA Paternity Testing',
  scy_item9_desc: 'Assistance with infant-parent DNA paternity testing, providing legal basis for repatriation procedures.',
  scy_item10_title: 'Newborn Repatriation',
  scy_item10_desc: 'Assistance with newborn return visa, travel permit and all repatriation procedures for smooth return home.',
  scy_item11_title: 'Local Kyrgyzstan Service',
  scy_item11_desc: 'Medical interpreter accompaniment, airport pickup (one round trip), hospital-area hotel medical transport.',
  scy_item12_title: 'Living Essentials',
  scy_item12_desc: '2 SIM cards, 1 power adapter, apartment/hotel booking assistance.',
  // Surrogacy extra costs
  scy_extra1_title: 'Second Transfer Surgery',
  scy_extra1_price: '$3,000',
  scy_extra1_desc: 'Includes examination and medication, when first transfer is unsuccessful',
  scy_extra2_title: 'Surrogate Replacement',
  scy_extra2_price: '$4,000/time',
  scy_extra2_desc: 'Replacement of surrogate under special circumstances',
  scy_extra3_title: 'Embryo Transport Fee',
  scy_extra3_price: '$12,000/time',
  scy_extra3_desc: 'International embryo transport operation cost',
  scy_extra4_title: 'Twin Pregnancy Compensation',
  scy_extra4_price: '$12,000',
  scy_extra4_desc: 'Additional twin compensation for pregnancy test and birth',
  scy_extra5_title: 'Natural Twin Split',
  scy_extra5_price: '$12,000',
  scy_extra5_desc: 'Compensation for natural embryo splitting into twins',
  scy_extra6_title: 'C-Section Additional',
  scy_extra6_price: '$4,000/time',
  scy_extra6_desc: 'Additional compensation for cesarean section surgery',
  scy_extra7_title: 'E-Visa',
  scy_extra7_price: 'Current rate',
  scy_extra7_desc: 'Kyrgyzstan electronic visa',
  scy_extra8_title: 'Round-Trip Flights',
  scy_extra8_price: 'Current rate',
  scy_extra8_desc: 'Round-trip airfare at actual cost',
  scy_extra9_title: 'Pregnancy Preservation',
  scy_extra9_price: 'At actual cost',
  scy_extra9_desc: 'Pregnancy preservation medication and treatment',
  scy_extra10_title: 'Premature Incubator',
  scy_extra10_price: 'Varies by hospital',
  scy_extra10_desc: 'Newborn premature incubator cost',
  scy_extra11_title: 'Nanny/Babysitter',
  scy_extra11_price: '~$1,500/month',
  scy_extra11_desc: 'Cost of hiring nanny or babysitter',
  scy_extra12_title: 'Hague Apostille Notarization',
  scy_extra12_price: 'At actual cost',
  scy_extra12_desc: 'Hague certification and notary office fees',
  // Surrogacy plan items
  scy_plan_economy_item1: 'Surrogate screening and necessary checkups',
  scy_plan_economy_item2: 'Blood pregnancy test',
  scy_plan_economy_item3: 'Monthly necessary prenatal checkups',
  scy_plan_economy_item4: 'Surrogate living compensation',
  scy_plan_economy_item5: '1-year embryo cryopreservation',
  scy_plan_economy_item6: 'Licensed maternity hospital natural birth',
  scy_plan_economy_item7: 'Birth medical certificate processing',
  scy_plan_economy_item8: 'DNA paternity testing assistance',
  scy_plan_economy_item9: 'Newborn repatriation assistance',
  scy_plan_economy_item10: 'Hague apostille full assistance',
  scy_plan_economy_item11: 'Local interpreter + airport pickup',
  scy_plan_premium_item1: 'All Economy Plan contents included',
  scy_plan_premium_item2: 'Surrogate pregnancy risk compensation',
  scy_plan_premium_item3: 'Dedicated delivery companion',
  scy_plan_premium_item4: 'Full prenatal report interpretation',
  scy_plan_premium_item5: 'Postpartum hospital paperwork assistance',
  scy_plan_premium_item6: 'Newborn return visa assistance',
  scy_plan_premium_item7: 'More distributed payment milestones',
  scy_plan_premium_item8: 'Lower per-payment pressure',
  scy_plan_premium_item9: 'VIP medical consultant service',
  scy_plan_premium_item10: 'Pregnancy psychological support service',
  scy_plan_premium_item11: 'Emergency medical plan protection',
  // Surrogacy plan note items
  scy_plan_inc_item1: 'Surrogate health screening and management fee',
  scy_plan_inc_item2: 'One embryo transfer medical fee',
  scy_plan_inc_item3: 'Full pregnancy medical monitoring',
  scy_plan_inc_item4: 'Licensed maternity hospital natural birth cost',
  scy_plan_inc_item5: 'Birth certificate legal document processing',
  scy_plan_inc_item6: 'DNA paternity testing assistance',
  scy_plan_inc_item7: 'Chinese consultant full service',
  scy_plan_extra_item1: 'Client flights and accommodation in Kyrgyzstan',
  scy_plan_extra_item2: 'Chinese passport application and household registration fee',
  scy_plan_extra_item3: 'Second transfer surgery fee',
  scy_plan_extra_item4: 'Pregnancy preservation fee',
  scy_plan_extra_item5: 'Nanny/babysitter cost',
  scy_plan_extra_item6: 'Twin pregnancy additional compensation',

  // Full service detail page
  full_breadcrumb: 'IVF + Surrogacy',
  full_label: 'IVF + Surrogacy',
  full_page_title: 'IVF + Surrogacy',
  full_hero_desc: 'One-stop full chain service from ovulation stimulation to baby returning home. Economy/Premium/Comprehensive three plans, complete IVF + surrogacy process.',
  full_stat_price: 'Economy Plan From',
  full_stat_plans: 'Flexible Plans',
  full_stat_steps: 'Full Process Service',
  full_stat_legal: 'Legal Parental Rights',
  full_process_title: 'Complete IVF + Surrogacy Process',
  full_process_sub: 'From stimulation to baby repatriation, one-stop full chain service',
  full_process_label: 'Complete Process',
  full_cta_title: 'Begin Your IVF + Surrogacy Journey',
  full_cta_desc: 'Professional medical consultant provides free consultation and recommends the best IVF + surrogacy plan',
  // Fertility steps
  full_step1_title: 'Plan & Assessment',
  full_step1_dur: 'Week 1-2',
  full_step1_desc: 'Remote specialist consultation, comprehensive fertility assessment for both partners. Includes ovarian reserve (AMH/AFC), semen analysis, uterine evaluation, karyotype testing, and personalized IVF + surrogacy plan.',
  full_step1_p1: 'Remote + local specialist consultation',
  full_step1_p2: 'Ovarian reserve AMH/AFC testing',
  full_step1_p3: 'Semen analysis & morphology',
  full_step1_p4: 'Karyotype chromosome testing',
  full_step2_title: 'Controlled Ovarian Stimulation',
  full_step2_dur: 'Week 2-4',
  full_step2_desc: 'Personalized stimulation protocol with daily gonadotropin injections to stimulate multiple follicle development. Close monitoring of follicle growth.',
  full_step2_p1: 'Personalized stimulation protocol',
  full_step2_p2: 'Continuous ultrasound monitoring',
  full_step2_p3: 'Dynamic hormone level testing',
  full_step2_p4: 'Timely protocol adjustments',
  full_step3_title: 'Egg Retrieval',
  full_step3_dur: 'Week 4-5',
  full_step3_desc: 'When dominant follicles mature, transvaginal ultrasound-guided retrieval under IV sedation, approximately 20-30 minutes. Abdominal retrieval option available if needed.',
  full_step3_p1: 'IV sedation painless retrieval',
  full_step3_p2: 'Ultrasound precision guidance',
  full_step3_p3: 'Experienced physician operation',
  full_step3_p4: 'Same-day rest and recovery',
  full_step4_title: 'ICSI & Embryo Culture',
  full_step4_dur: 'Day 5-10',
  full_step4_desc: 'ICSI single sperm injection into each oocyte. Fertilized eggs cultured 5-7 days to blastocyst stage with time-lapse imaging monitoring.',
  full_step4_p1: 'ICSI single sperm injection',
  full_step4_p2: 'All embryos cultured to blastocyst',
  full_step4_p3: 'Time-lapse dynamic monitoring',
  full_step4_p4: 'Gardner grading system',
  full_step5_title: 'PGT-A Genetic Screening',
  full_step5_dur: 'Day 10-30',
  full_step5_desc: 'All blastocysts biopsied for PGT-A chromosome euploidy screening. Economy/Premium plans include single 8-embryo screening, Comprehensive plan includes multi-cycle PGT-A.',
  full_step5_p1: 'All embryos biopsied',
  full_step5_p2: 'PGT-A chromosome screening',
  full_step5_p3: '8 embryos included in package',
  full_step5_p4: 'PGT-M optional',
  full_step6_title: 'Embryo Transfer',
  full_step6_dur: 'Week 11-14',
  full_step6_desc: 'Highest-quality embryo transferred to surrogate uterus. Economy plan includes one transfer, Premium/Comprehensive plans include unlimited transfers. Blood HCG test 14 days post-transfer.',
  full_step6_p1: 'Ultrasound-guided precise transfer',
  full_step6_p2: 'Economy 1x / Premium & Comprehensive unlimited',
  full_step6_p3: '14-day blood HCG pregnancy test',
  full_step6_p4: 'Luteal support protocol',
  full_step7_title: 'Full Pregnancy Monitoring',
  full_step7_dur: 'Week 15-40',
  full_step7_desc: 'Professional medical team monitors surrogate health throughout pregnancy, monthly prenatal checkups, real-time report sync, video call coordination, pregnancy risk compensation.',
  full_step7_p1: 'Monthly prenatal report sync',
  full_step7_p2: 'Surrogate living compensation',
  full_step7_p3: 'Pregnancy risk compensation',
  full_step7_p4: '24/7 medical support',
  full_step8_title: 'Baby Birth',
  full_step8_dur: 'Around due date',
  full_step8_desc: 'Baby delivered naturally at licensed maternity hospital with dedicated companion. Parents directly registered as legal parents, postpartum paperwork and birth certificate assistance.',
  full_step8_p1: 'Licensed maternity hospital natural birth',
  full_step8_p2: 'Parents directly registered as legal parents',
  full_step8_p3: 'Professional newborn care',
  full_step8_p4: 'Full birth accompaniment',
  full_step9_title: 'Documents & Return Home',
  full_step9_dur: '1-2 months after birth',
  full_step9_desc: 'Assistance with DNA paternity testing, Hague apostille, newborn return visa, travel permit — full support to bring your baby home smoothly.',
  full_step9_p1: 'DNA paternity testing',
  full_step9_p2: 'Birth certificate + Hague apostille',
  full_step9_p3: 'Return visa / travel permit',
  full_step9_p4: 'Full repatriation support',
  // Fertility pricing
  full_plan_economy: 'Economy Plan',
  full_plan_economy_badge: 'Budget Choice',
  full_plan_economy_desc: 'One stimulation one transfer, optimal choice when everything goes smoothly',
  full_plan_premium: 'Premium Plan',
  full_plan_premium_badge: 'Most Popular',
  full_plan_premium_desc: 'One stimulation with unlimited transfers, pregnancy risk compensation, ideal for younger clients',
  full_plan_comprehensive: 'Comprehensive Plan',
  full_plan_comprehensive_badge: 'Full Protection',
  full_plan_comprehensive_desc: 'Unlimited stimulation and transfers, suitable for clients needing multiple stimulation cycles',
  full_plan_btn: 'Get Detailed Quote',
  full_plan_section_label: 'Pricing Plans',
  full_plan_section_title: 'IVF + Surrogacy Plan Comparison',
  full_plan_section_sub: 'Three flexible plans for different needs and budgets',
  full_plan_note_title: 'Cost Notes & Inclusions',
  full_plan_note_inc_title: 'Typically Included:',
  full_plan_note_extra_title: 'Possible Additional Costs:',
  full_plan_note_footer: '* Reference ranges only. Actual costs vary by plan selection, medical conditions, and exchange rates. Contact our medical consultant for a precise personalized quote. Comprehensive Plan unlimited stimulation is valid for 1 year from first egg retrieval date.',
  full_plan_economy_item1: 'One stimulation and egg retrieval',
  full_plan_economy_item2: 'ICSI single sperm injection',
  full_plan_economy_item3: 'All embryo culture 5-7 days',
  full_plan_economy_item4: 'PGT-A screening (single 8 embryos)',
  full_plan_economy_item5: 'One transfer per cycle',
  full_plan_economy_item6: 'Surrogate screening and checkup',
  full_plan_economy_item7: 'Full pregnancy monitoring',
  full_plan_economy_item8: 'Licensed maternity hospital natural birth',
  full_plan_economy_item9: 'Birth certificate + repatriation',
  full_plan_economy_item10: '1-year embryo cryopreservation',
  full_plan_premium_item1: 'All Economy Plan contents included',
  full_plan_premium_item2: 'Unlimited transfers per cycle',
  full_plan_premium_item3: 'Surrogate pregnancy risk compensation',
  full_plan_premium_item4: 'Dedicated delivery companion',
  full_plan_premium_item5: 'Full prenatal report interpretation',
  full_plan_premium_item6: 'DNA paternity testing assistance',
  full_plan_premium_item7: 'Newborn return visa assistance',
  full_plan_premium_item8: 'More distributed payment milestones',
  full_plan_premium_item9: 'VIP medical consultant service',
  full_plan_premium_item10: 'Emergency medical plan protection',
  full_plan_comp_item1: 'All Premium Plan contents included',
  full_plan_comp_item2: 'Unlimited stimulation and egg retrieval',
  full_plan_comp_item3: 'Unlimited embryo transfers',
  full_plan_comp_item4: 'Multi-cycle PGT-A screening',
  full_plan_comp_item5: 'First two cycle medications included',
  full_plan_comp_item6: 'Multi-cycle embryo freezing',
  full_plan_comp_item7: 'Surrogate accident insurance',
  full_plan_comp_item8: 'Professional interpreter full accompaniment',
  full_plan_comp_item9: 'Unlimited stimulation valid for 1 year',
  full_plan_comp_item10: 'Highest success rate guarantee',
  full_plan_note_inc_item1: 'Doctor consultation fee and plan design',
  full_plan_note_inc_item2: 'Ovulation medication cost (Kyrgyzstan)',
  full_plan_note_inc_item3: 'Egg retrieval surgery and anesthesia fee',
  full_plan_note_inc_item4: 'ICSI laboratory fee',
  full_plan_note_inc_item5: 'Embryo culture and PGT-A screening',
  full_plan_note_inc_item6: 'Embryo transfer surgery fee',
  full_plan_note_inc_item7: 'Surrogate screening management fee',
  full_plan_note_inc_item8: 'Pregnancy medical monitoring fee',
  full_plan_note_inc_item9: 'Natural birth cost and newborn care',
  full_plan_note_inc_item10: 'Repatriation legal documents',
  full_plan_note_extra_item1: 'Client flights and accommodation in Kyrgyzstan',
  full_plan_note_extra_item2: 'Chinese passport application and household registration fee',
  full_plan_note_extra_item3: 'Domestic stimulation medication and monitoring fee',
  full_plan_note_extra_item4: 'PGT-M genetic screening (optional)',
  full_plan_note_extra_item5: 'Additional embryo PGT-A screening',
  full_plan_note_extra_item6: 'Twin pregnancy additional compensation',
  full_plan_note_extra_item7: 'C-section additional compensation',
  full_plan_note_extra_item8: 'Nanny/babysitter cost',
  // Services overview features
  svc_ivf_feature1: 'Remote + local specialist consultation',
  svc_ivf_feature2: 'Joint bilateral stimulation plan',
  svc_ivf_feature3: 'ICSI single sperm injection',
  svc_ivf_feature4: 'All embryo biopsy + PGT-A',
  svc_ivf_feature5: '8 embryo genetic screening',
  svc_ivf_feature6: '1-year embryo cryopreservation',
  svc_surrogacy_feature1: 'Strict surrogate screening',
  svc_surrogacy_feature2: 'Full pregnancy monitoring',
  svc_surrogacy_feature3: 'Licensed hospital natural birth',
  svc_surrogacy_feature4: 'DNA paternity testing',
  svc_surrogacy_feature5: 'Birth certificate + return visa',
  svc_surrogacy_feature6: 'Hague apostille assistance',
  svc_full_feature1: 'IVF + surrogacy full process',
  svc_full_feature2: 'Three flexible plan options',
  svc_full_feature3: 'Unlimited transfers (Premium/Comprehensive)',
  svc_full_feature4: 'Multi-cycle stimulation (Comprehensive)',
  svc_full_feature5: 'Pregnancy risk compensation',
  svc_full_feature6: 'One-stop repatriation document processing',

  // Common
  read_more: 'Read More',
  back: 'Back',
  loading: 'Loading...',
  submit: 'Submit',
  close: 'Close',
  home: 'Home',
  retry: 'Retry',
};

export default common;